import {
  AppClaimsEnum,
  ApplicationUserDTO,
  ClaimClient,
  LicenseDataDTO,
  UserClient,
  UserSessionDataDTO,
} from "@src/apis/ModularClient";
import { IPromise } from "angular";

export class IndexService {
  private _userSessionPromise: IPromise<UserSessionDataDTO>;
  private _currentUserPromise: IPromise<ApplicationUserDTO>;
  private _licenseDataPromise: IPromise<LicenseDataDTO>;

  static $inject = ["ClaimClient", "UserClient"];
  constructor(
    protected claimClient: ClaimClient,
    protected userClient: UserClient,
  ) {}
  initialise() {
    this._userSessionPromise = this.claimClient.getMyUserSessionData();
    this._currentUserPromise = this.userClient.getCurrentUser();
    this._licenseDataPromise = this.userClient.getCurrentUserLicenseData();
  }
  get currentUserLicenseData(): IPromise<LicenseDataDTO> {
    return this._licenseDataPromise;
  }

  get currentUserRoles(): IPromise<string[]> {
    const sessionData = this._userSessionPromise;
    return sessionData.then((sessionData) => mapClaimsToRoles(sessionData.claims));
  }

  get currentUser(): IPromise<ApplicationUserDTO> {
    return this._currentUserPromise;
  }

  get currentUserId(): IPromise<number> {
    const sessionData = this._userSessionPromise;
    return sessionData.then((sessionData) => sessionData.userId);
  }
}

function mapClaimsToRoles(claims: AppClaimsEnum[]): string[] {
  const claimRoleMap: { [key in AppClaimsEnum]?: string } = {
    [AppClaimsEnum.Admin_AllowRead]: "Admin",
    [AppClaimsEnum.Broker_AllowRead]: "Broker",
    [AppClaimsEnum.Client_AllowRead]: "Client",
    [AppClaimsEnum.Introducer_AllowRead]: "Introducer",
    [AppClaimsEnum.Lender_AllowRead]: "Lender",
    [AppClaimsEnum.OrganisationAdmin_AllowRead]: "OrganisationAdmin",
  };

  if (claims.includes(AppClaimsEnum.Admin_AllowRead)) {
    return ["Admin"];
  }

  
  const isOrgAdmin = claims.includes(AppClaimsEnum.OrganisationAdmin_AllowRead);
  const isBroker = claims.includes(AppClaimsEnum.Broker_AllowRead);

  if (isOrgAdmin && isBroker) {
    return ["OrganisationAdmin", "Broker"];
  }

  if (isBroker) {
    return ["Broker"];
  }


  if (claims.includes(AppClaimsEnum.Broker_AllowRead)) {
    return ["Broker"];
  }

  return Array.from(
    new Set(claims.map((claim) => claimRoleMap[claim]).filter((role): role is string => role !== undefined)),
  );
}
